import type { RouteRecordRaw } from 'vue-router';

export const catalogRoutes: RouteRecordRaw[] = [
  {
    path: 'catalog/products',
    name: 'catalog.products',
    component: () => import('./pages/ProductsListPage.vue'),
    meta: { title: 'Products', requiresAuth: true, permission: 'view_products' },
  },
  {
    path: 'catalog/products/new',
    name: 'catalog.products.create',
    component: () => import('./pages/ProductFormPage.vue'),
    meta: { title: 'New product', requiresAuth: true },
  },
  {
    path: 'catalog/products/:id/edit',
    name: 'catalog.products.edit',
    component: () => import('./pages/ProductFormPage.vue'),
    meta: { title: 'Edit product', requiresAuth: true },
  },
  {
    path: 'catalog/categories',
    name: 'catalog.categories',
    component: () => import('./pages/CategoriesPage.vue'),
    meta: { title: 'Product categories', requiresAuth: true },
  },
  {
    path: 'catalog/stock/movements',
    name: 'catalog.stock.movements',
    component: () => import('./pages/StockMovementsPage.vue'),
    meta: { title: 'Stock movements', requiresAuth: true, permission: 'view_stock_movements' },
  },
  {
    path: 'catalog/stock/import',
    name: 'catalog.stock.import',
    component: () => import('./pages/StockImportPage.vue'),
    meta: { title: 'Import from receipt', requiresAuth: true, permission: 'create_stocks' },
  },
  {
    path: 'catalog/stock',
    name: 'catalog.stock',
    component: () => import('./pages/StockPage.vue'),
    meta: { title: 'Stock', requiresAuth: true },
  },
  {
    path: 'catalog/bom',
    name: 'catalog.bom',
    component: () => import('./pages/BomPage.vue'),
    meta: { title: 'Bill of materials', requiresAuth: true },
  },
  {
    path: 'catalog/manufacturing',
    name: 'catalog.manufacturing',
    component: () => import('./pages/ManufacturingPage.vue'),
    meta: { title: 'Manufacturing', requiresAuth: true },
  },
];
